module.exports = __webpack_public_path__ + "static/L2_ux_5_3_eg-8005423772493947e50477cd97b9c5f3.png";